// FNC1（GS1区切り）
const FNC1 = String.fromCharCode(29);

// AI(アプリケーション識別子)定義
const AI_DEFINITIONS = {
    "01": { fixed: true, length: 14 },  // GTIN
    "17": { fixed: true, length: 6 },   // 使用期限
    "30": { fixed: false, maxLength: 8 },  // 数量
    "10": { fixed: false, maxLength: 20 }, // ロット
    "21": { fixed: false, maxLength: 20 }  // シリアル
};

// GS1パース
export const parseGs1 = (code) => {

    // GS1識別子削除
    let target = code.replace(/^\](C1|d2|Q3)/, '');

    let index = 0;
    const result = {};

    while (index < target.length) {
        // 先頭に区切り文字が残っている場合はスキップする
        if (target.charAt(index) === FNC1) {
            index++;
            continue;
        }

        let ai = null;

        // AI検出（4桁→2桁）
        for (let len = 4; len >= 2; len--) {
            const candidate = target.substring(index, index + len);
            if (AI_DEFINITIONS[candidate]) {
                ai = candidate;
                break;
            }
        }

        if (!ai) {
            index++;
            continue;
        }

        const def = AI_DEFINITIONS[ai];
        index += ai.length;

        // 固定長
        if (def.fixed) {
            result[ai] = target.substring(index, index + def.length);
            index += def.length;
            // 固定長データの直後にFNC1がある場合は、次のループのために1文字進めておく
            if (target.charAt(index) === FNC1) {
                index++;
            }
            continue;
        }

        // 可変長
        let endIndex = target.length;

        // FNC1優先
        const fnc1Pos = target.indexOf(FNC1, index);

        if (fnc1Pos !== -1) {
            endIndex = fnc1Pos;
        }

        let value = target.substring(index, endIndex);

        if (def.maxLength) {
            value = value.substring(0, def.maxLength);
        }

        result[ai] = value;

        // FNC1があれば1文字飛ばす
        index = (fnc1Pos !== -1) ? endIndex + 1 : endIndex;
    }

    return result;
};

// バーコード解析
export const getBarcodeInfo = (code) => {

    // 判定用は識別子除去
    const cleaned = code.replace(/^\](C1|d2|Q3)/, '');

    // 短縮JAN（8桁）
    if (/^\d{8}$/.test(cleaned)) {
        return {
            type: "B0",
            code: cleaned
        };
    }

    // JAN（13桁）
    if (/^\d{13}$/.test(cleaned)) {
        return {
            type: "A0",
            code: cleaned
        };
    }

    // GS1
    if (cleaned.startsWith("01") && cleaned.length >= 16) {

        const parsed = parseGs1(code);

        return {
            type: cleaned.length === 16 ? "R0" : "V0",
            gtin: parsed["01"] || null,
            lot: parsed["10"] || null,
            expirationDate: parsed["17"] || null,
            quantity: parsed["30"] || null,
            serial: parsed["21"] || null
        };
    }

    // 不明なバーコード
    return {
        type: null
    };
};